// 9fbef606107a605d69c0edbcd8029e5d
import { PROMOTIONS_REDUCER_KEY_PATTERN } from '../../../../../constants/reducer.constants';

export const SET_PROMOTIONS_LOADING_STATE = `${PROMOTIONS_REDUCER_KEY_PATTERN}PROMOTIONS_REDUCER_KEY_PATTERN`;

export const PROMOTIONS_CONSTANT = {
  FETCH_ALL_PROMOTIONS: 'FETCH_ALL_PROMOTIONS',
  FETCH_PROMOTION_DETAILS: 'FETCH_PROMOTION_DETAILS',
  SET_ALL_PROMOTIONS: 'SET_ALL_PROMOTIONS',
  SET_PROMOTIONS_DETAILS: 'SET_PROMOTIONS_DETAILS',
  SET_APPLIED_PROMOTION: 'SET_APPLIED_PROMOTION',
  REMOVE_APPLIED_PROMOTION: 'REMOVE_APPLIED_PROMOTION',
  FETCH_APPLIED_PROMOTIONS: 'FETCH_APPLIED_PROMOTIONS',
  SET_CACHED_PROMOTIONS: 'SET_CACHED_PROMOTIONS',
  UPDATE_CHECKBOX: 'UPDATE_CHECKBOX',
  RESET_APPLIED_PROMOTIONS: 'RESET_APPLIED_PROMOTIONS',
  RESET_REMOVED_PROMOTIONS: 'RESET_REMOVED_PROMOTIONS',
  SET_ALL_OFFER_TYPE_BASED_PROMOTIONS_DATA: 'SET_ALL_OFFER_TYPE_BASED_PROMOTIONS_DATA',
};

export const APPLIED_PDP_PROMOTIONS = 'APPLIED_PDP_PROMOTIONS';

export default { PROMOTIONS_CONSTANT, SET_PROMOTIONS_LOADING_STATE };
